var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRadioChecked = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 24,
  viewBox: "0 0 18 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 12,
  r: 9,
  fill: "white"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 12,
  r: 8,
  stroke: "currentColor",
  strokeWidth: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 12,
  r: 4,
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRadioChecked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/radioChecked.68a65a3a3ea09f7fdd500ef4b2123ed3.svg";